import { render, staticRenderFns } from "./editPassword.vue?vue&type=template&id=7dd62d60&scoped=true&"
import script from "./editPassword.vue?vue&type=script&lang=js&"
export * from "./editPassword.vue?vue&type=script&lang=js&"
import style0 from "./editPassword.vue?vue&type=style&index=0&id=7dd62d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd62d60",
  null
  
)

export default component.exports